import { useState } from "react";

function BuildHistoryMenu({
  stages = [],
  currentStageId,
  onSelectStage,
  onCreateStage,
  canCreateStage = false
}) {
  const [open, setOpen] = useState(false);

  const currentStage =
    stages.find((s) => s.id === currentStageId) || stages[0];

    const displayStageName = (stage) => {
  if (!stage?.name || stage.name === "Current Build") {
    return "Original Build";
  }

  return stage.name;
};

  return (
    <div style={containerStyle}>
      <button
        style={buttonStyle}
        onClick={() => setOpen(!open)}
      >
        <div>
       <div style={labelStyle}>Build Phase</div>
          <div style={nameStyle}>
            {displayStageName(currentStage)}
          </div>
        </div>

        <span>{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div style={menuStyle}>
          {stages.map((stage) => (
            <button
              key={stage.id}
              style={{
                ...stageButtonStyle,
                backgroundColor:
                  stage.id === currentStageId
                    ? "#2a2a2a"
                    : "transparent"
              }}
              onClick={() => {
                onSelectStage(stage.id);
                setOpen(false);
              }}
            >
              {stage.id === currentStageId && "✓ "}
             {displayStageName(stage)}
            </button>
          ))}

          <div style={dividerStyle} />

        </div>
      )}
    </div>
  );
}

const containerStyle = {
  marginBottom: "20px"
};

const buttonStyle = {
  width: "100%",
  background: "#1c1c1c",
  color: "white",
  border: "1px solid #333",
  borderRadius: "12px",
  padding: "14px 16px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer"
};

const labelStyle = {
  fontSize: "12px",
  opacity: 0.7
};

const nameStyle = {
  fontSize: "16px",
  fontWeight: "bold",
  marginTop: "2px"
};

const menuStyle = {
  marginTop: "8px",
  background: "#1a1a1a",
  border: "1px solid #333",
  borderRadius: "12px",
  overflow: "hidden"
};

const stageButtonStyle = {
  width: "100%",
  padding: "14px",
  border: "none",
  color: "white",
  textAlign: "left",
  cursor: "pointer"
};

const dividerStyle = {
  height: "1px",
  background: "#333"
};

const archiveButtonStyle = {
  width: "100%",
  padding: "14px",
  background: "#111",
  color: "#888",
  border: "none",
  cursor: "not-allowed"
};

export default BuildHistoryMenu;